import { pageHead } from "@/lib/route-head";
import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const Events = lazy(() => import("@/pages/Events"));

export const Route = createFileRoute("/events")({
  head: () => pageHead({ path: "/events", title: "Amorette Experiences | Curated Dining Evenings", description: "Browse upcoming Amorette curated dining evenings. Membership is required to reserve a seat." }),
  component: Events,
});
